"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _arrayWithHoles;

var _isArray = _interopRequireDefault(require("../../core-js/array/is-array"));

function _arrayWithHoles(arr) {
  if ((0, _isArray.default)(arr)) return arr;
}